
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { LegacyComment, IContentVisitInfo, UserStatusEnum } from 'lingo2-models';
import { IContentStats } from 'lingo2-models';
import { first, takeUntil, tap } from 'rxjs/operators';
import striptags from 'striptags';
import { GameService } from '../../services/game.service';
import { CommentService } from '../../services/comment.service';
import { ContentService } from '../../services/content.service';
import { Subject } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { IconsService } from '../../services/icons.service';
import { CustomLocaleModule } from '@onclass/oc-custom-locale';

@Component({
  selector: 'app-lesson-review',
  standalone: true,
  imports: [FormsModule, CustomLocaleModule],
  templateUrl: './lesson-review.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./lesson-review.component.scss'],
})
export class LessonReviewComponent implements OnInit, OnDestroy {
  @Input() set content_id(value: string) {
    this._content_id = value;
    if (this._content_id) {
      this.init();
    }
  }
  @Output() submitted = new EventEmitter<boolean>();

  public comment: string = '';
  public is_submitted = false;
  public submitting = false;
  public svgSetIcon = IconsService.svgsetIconUrl;
  public visit_info: Partial<IContentVisitInfo> = {};
  public visit_info_loaded = false;
  public is_commented = false;
  public comments_loaded = false;
  public is_guest = true;
  public stats: Partial<IContentStats> = {};
  protected readonly destroyed$ = new Subject<boolean>();


  private _commentHeight: number = 37;
  private rating = -1;
  private el: any;

  private _content_id: string = '';

  constructor(
    private commentService: CommentService,
    private gameService: GameService,
    private elementRef: ElementRef,
    private contentService: ContentService,
  ) {
    this.el = this.elementRef.nativeElement;
    this.onCommentChange();
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  private init() {
    this.loadVisitInfo();
    this.loadCommentsDigest();
    this.gameService.myUser$
    .pipe(tap((me) => {
      if (me) {
        this.is_guest = me.status === UserStatusEnum.guest;
      }
    }))
    .subscribe()
  }

  public like() {
    this.contentService
      .like(this._content_id)
      .pipe(first(), takeUntil(this.destroyed$))
      .subscribe({
        next: () => this.loadVisitInfo(),
      });
  }

  public dislike() {
    this.contentService
      .dislike(this._content_id)
      .pipe(first(), takeUntil(this.destroyed$))
      .subscribe({
        next: () => this.loadVisitInfo(),
      });
  }

  public onCommentChange() {
    const pre = this.el.querySelector('pre');
    if (!pre) {
      return;
    }
    const maxHeight = 126;
    const currentHeight = pre.offsetHeight;
    this._commentHeight = currentHeight > maxHeight ? maxHeight : currentHeight;
  }

  get commentHeight(): number {
    return this._commentHeight;
  }

  public submit() {
    if (this.submitting) {
      return;
    }

    const comment = striptags(this.comment).trim();
    if (this.rating < 1 && comment.length < 1) {
      return;
    }

    this.submitting = true;

    // https://app.clickup.com/t/9wv75f - ревью урока записывать не в content_review, а просто в comments

    const values: Partial<LegacyComment> = {
      text: comment,
      // TODO new thread default options OR thread type
    };
    this.commentService
      .createThreadComment(this._content_id, values)
      .pipe(first(), takeUntil(this.destroyed$))
      .subscribe({
        next: () => {
          this.is_submitted = true;
          this.submitting = false;
          this.submitted.emit(true);
        },
      });
  }

  private loadVisitInfo() {
    this.contentService
      .getById(this._content_id, false, ['visit_info', 'stats'])
      .pipe(first(), takeUntil(this.destroyed$))
      .subscribe({
        next: (content) => {
          this.stats = content.stats!;
          this.visit_info = content.visit_info!;
          this.visit_info_loaded = true;
        },
      });
  }

  private loadCommentsDigest() {
    this.commentService
      .getThreadDigest(this._content_id)
      .pipe(first(), takeUntil(this.destroyed$))
      .subscribe({
        next: (response) => {
          this.is_commented = response ? response.is_commented : false;
          this.comments_loaded = true;
        },
      });
  }
}
